import {
  createPromiseAction,
  rejectPromiseAction,
  resolvePromiseAction,
} from 'redux-saga-promise-actions'
import { call, put, takeEvery } from 'redux-saga/effects'
import { authAPI } from '../../api'
import {
  AUTH_VERIFY_EMAIL_FAILED,
  AUTH_VERIFY_EMAIL_REQUEST,
  AUTH_VERIFY_EMAIL_SUCCESS,
} from './actionTypes'

export const authVerifyEmailPA = createPromiseAction(
  AUTH_VERIFY_EMAIL_REQUEST,
  AUTH_VERIFY_EMAIL_SUCCESS,
  AUTH_VERIFY_EMAIL_FAILED
)()

function* verify(action) {
  try {
    const response = yield call(authAPI.verifyEmail, action.payload)
    const { data } = response

    yield put(authVerifyEmailPA.success({}))

    resolvePromiseAction(action, {})
  } catch (error) {
    if (!error.response) {
      throw error
    }
    rejectPromiseAction(action, error.response.data)
  }
}

export function* verifyEmailSaga() {
  yield takeEvery(authVerifyEmailPA.request, verify)
}
